import { useEffect, useRef, useState } from 'react'

export function useDebouncedState<T = any>(
  defaultValue: T,
  wait: number,
  options = { leading: false }
) {
  const [value, setValue] = useState(defaultValue)
  const timeoutRef = useRef<number>(null)
  const leadingRef = useRef(true)

  const clearTimeout = () => window.clearTimeout(timeoutRef.current)
  useEffect(() => clearTimeout, [])

  const debouncedSetValue = (newValue: T, callback?: (newValue: T) => void) => {
    clearTimeout()
    if (leadingRef.current && options.leading) {
      setValue(newValue)
      if (callback) callback(newValue)
    } else {
      timeoutRef.current = window.setTimeout(() => {
        leadingRef.current = true
        setValue(newValue)
        if (callback) callback(newValue)
      }, wait)
    }
    leadingRef.current = false
  }

  return [value, debouncedSetValue, setValue] as const
}
